<div class="fs-2 with-close" mat-dialog-title>
    Cette annonce est reservée à nos membres premium
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true" *ngIf="data.close"></i>
</div>
<div mat-dialog-content>
    <b>
        Rejoignez LyBox dès maintenant pour découvrir les meilleurs opportunités.
    </b>
    <div class="row d-flex justify-content-around align-items-stretch pricing mt-3">
        <div class="col-12 col-lg-6 p-2 col-essentiel">
            <div class="pricing-light pt-3 pb-2 text-center">
                <h4 class="fs-3 pb-3 essentiel pb-3">Essentiel</h4>
                <b class="price fs-2 pricing-annuel-value"
                   *ngIf="user.p == '0' || user.p == '1'">33,25€<span
                    class="fs-5">/mois</span></b>
                <b class="price fs-2 pricing-mensuel-value"
                   *ngIf="user.p == '0' || user.p == '1'">39,90€<span
                    class="fs-5">/mois</span></b>

                <b class="price fs-2 pricing-annuel-value" *ngIf="user.p == '2'">16,57€<span
                    class="fs-5">/mois</span></b>
                <b class="price fs-2 pricing-mensuel-value" *ngIf="user.p == '2'">19,90€<span
                    class="fs-5">/mois</span></b>

                <b class="price fs-2 pricing-annuel-value" *ngIf="user.p == '3'">24€<span
                    class="fs-5">/mois</span></b>
                <b class="price fs-2 pricing-mensuel-value" *ngIf="user.p == '3'">29€<span
                    class="fs-5">/mois</span></b>
                <ul class="pricing-features mt-3">
                    <li class="include">Extension navigateur</li>
                    <li class="include">Simulateur d’investissement locatif</li>
                    <li class="include">Moteur de recherche immobilier</li>
                    <li>Alertes mail</li>
                    <li>Export PDF</li>
                </ul>
                <a class="btn btn-outline-primary"
                   *ngIf="(user.plan == '' || user.plan == 'trial') && user.pro_plan == ''"
                   (click)="onYesClick('essentiel')">Selectionner
                </a>
            </div>
        </div>
        <div class="col-12 col-lg-6 p-2 col-expert">
            <div class="pricing-light pt-3 pb-2 text-center">
                <h4 class="fs-3 expert pb-3">Expert</h4>
                <b class="price fs-2 pricing-annuel-value"
                   *ngIf="user.p == '0' || user.p == '1'">49,91€<span
                    class="fs-5">/mois</span></b>
                <b class="price fs-2 pricing-mensuel-value"
                   *ngIf="user.p == '0' || user.p == '1'">59,90€<span
                    class="fs-5">/mois</span></b>

                <b class="price fs-2 pricing-annuel-value" *ngIf="user.p == '2'">24,92€<span
                    class="fs-5">/mois</span></b>
                <b class="price fs-2 pricing-mensuel-value" *ngIf="user.p == '2'">29,90€<span
                    class="fs-5">/mois</span></b>

                <b class="price fs-2 pricing-annuel-value" *ngIf="user.p == '3'">49€<span
                    class="fs-5">/mois</span></b>
                <b class="price fs-2 pricing-mensuel-value" *ngIf="user.p == '3'">59€<span
                    class="fs-5">/mois</span></b>

                <ul class="pricing-features mt-3">
                    <li class="include">Extension navigateur</li>
                    <li class="include">Simulateur d’investissement locatif</li>
                    <li class="include">Moteur de recherche immobilier</li>
                    <li class="include">Alertes mail</li>
                    <li class="include">Export PDF</li>
                </ul>
                <a class="btn btn-primary"
                   *ngIf="(user.plan == '' || user.plan == 'trial') && user.pro_plan == ''"
                   (click)="onYesClick('expert')">Selectionner
                </a>
            </div>
        </div>
    </div>
</div>
